import { Component, Input, EventEmitter, Output } from '@angular/core';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { createResourceContact, JoiResource } from 'globals/store/resources.data';
import { ResourceContact } from 'globals/store/resources.data';
import { ManageResourceContactData, ManageResourceContactComponent } from './manage-resource-contact.component';
import { MatDialog } from '@angular/material/dialog';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { JoiTemplate, getJoiTemplate } from 'globals/store/publish.data';
import { ResourceContactCardComponent } from './resource-contact-card.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'resource-contact-list',
    template: `
<add-manage-wrapper 
  cdkDropList 
  [useH3ForTitle]="true"
  [wrapperTitle]="'Contacts'"
  [hideHRule]="true" 
  [openLabel]="'+ ADD CONTACT'" 
  (open)="addContact()"
  (cdkDropListDropped)="dropContactIds($event)">
  <div class="drag-wrapper" cdkDrag *ngFor="let contact of resource.contacts; last as last; trackBy: trackByContact" >
    <icon class="handle" matIcon="drag_indicator" cdkDragHandle></icon>
    <resource-contact-card 
      [ngClass]="{ last: last }"
      [contact]="contact" 
      [resource]="resource"
      (click)="manageContact(contact)"
      (dotOption)="handleDotOption(contact, $event)"
    ></resource-contact-card>
  </div>
</add-manage-wrapper>  
`,
    styleUrls: ['../manage/entity-drag.scss'],
    styles: [`
  resource-contact-card { margin-top: 10px; }
  resource-contact-card.last { margin-bottom: 10px; }
`],
    standalone: true,
    imports: [ResourceContactCardComponent, AddManageWrapperComponent, CommonModule, CdkDragHandle, CdkDropList, CdkDrag],
})
export class ResourceContactListComponent { // this is a public component, remember
  @Input() resource: JoiResource
  @Input() public = false
  @Input() eventId: string
  @Input() publishCode: string = null
  @Input() fromTemplate = false
  @Input() template: JoiTemplate

  @Output() updated: EventEmitter<void> = new EventEmitter()

  constructor(private dialog: MatDialog) { }

  dropContactIds(event: CdkDragDrop<ResourceContact[]>) {
    moveItemInArray(this.resource.contacts, event.previousIndex, event.currentIndex)
    this.updated.emit()    
  }

  trackByContact(_, contact: ResourceContact) {
    return contact.id
  }

  async addContact() {
    const contact = createResourceContact()
    if (!this.resource.contacts.length) this.resource.primaryContactId = contact.id
    this.resource.contacts.push(contact)
    this.updated.emit()
    this.manageContact(contact)
  }

  handleDotOption(contact: ResourceContact, option: 'edit' | 'delete' | 'primarify') {
    switch (option) {
      case 'edit':
        this.manageContact(contact)
        break
      case 'primarify':
        this.resource.primaryContactId = contact.id
        this.updated.emit()
        break
      case 'delete':
        this.resource.contacts = this.resource.contacts.filter(c => c.id !== contact.id)
        this.updated.emit()
        break
    }
  }



  async manageContact(contact: ResourceContact) {
    const data: ManageResourceContactData = {
      contact,
      resource: this.resource,
      public: this.public,
      fromTemplate: this.fromTemplate,
      eventId: this.eventId,
      publishCode: this.publishCode,
      template: this.template
    }
    console.log(data)
    const result = await openDialogGetResult<ManageResourceContactData & { delete: boolean }>(this.dialog, ManageResourceContactComponent, {
      width: '450px',
      autoFocus: false,
      data,
      disableClose: true,
      backdropClass: 'backdrop',
    })
    if (result.hasOwnProperty('delete')) {
      this.resource.contacts = this.resource.contacts.filter(c => c.id !== contact.id)
    } else {
      const index = this.resource.contacts.findIndex(c => c.id === contact.id)
      this.resource.primaryContactId = result.resource.primaryContactId
      this.resource.contacts[index] = result.contact
    }
    this.updated.emit()
  }
}